export default "__VITE_ASSET__DDkaVEAJ__"